/* API Context */
import {getRequest, postRequest} from "../fetchWrapper";


/**
 * Récupération de la liste des catégories de médias.
 *
 * @param token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getGalleryCategoryList = (token) => {
    const url = `/api-v1/tools/gallery/category/list`
    return getRequest(url, token)
};

/**
 * Récupération de la liste des catégories de la galerie.
 *
 * @param token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getGalleryHeaderList = (token) => {
    const url = `/api-v1/tools/gallery/header/list`
    return getRequest(url, token)
};

/**
 * Récupération des contenus de la galerie.
 *
 * @param token Jeton d'authentification.
 * @param agencyId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getGalleryContent = (token, agencyId) => {
    const url = `/api-v1/tools/gallery/${agencyId}/content/`
    return getRequest(url, token)
};

/**
 * Ajout de nouveaux médias dans la galerie.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const uploadAgencyMedia = (token, body) => {
    const url = `/api-v1/tools/gallery/media/upload`
    return postRequest(url, body, token)
};

/**
 * Récupérations d'un medium d'une agence.
 *
 * @param token Jeton d'authentification.
 * @param mediumId Identifiant du medium.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getMediaInfos = (token, mediumId) => {
    const url = `/api-v1/tools/gallery/media/${mediumId}/infos`
    return getRequest(url, token)
}

/**
 * Déplacement d'un medium vers le haut.
 *
 * @param token Jeton d'authentification.
 * @param mediumId Identifiant du medium.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const uploadMediaPositionUp = (token, mediumId) => {
    const url = `/api-v1/tools/gallery/media/${mediumId}/up`
    return getRequest(url, token)
};

/**
 * Déplacement d'un medium vers le bas.
 *
 * @param token Jeton d'authentification.
 * @param mediumId Identifiant du medium.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const uploadMediaPositionDown = (token, mediumId) => {
    const url = `/api-v1/tools/gallery/media/${mediumId}/down`
    return getRequest(url, token)
};

/**
 * Suppression d'un medium de la base de données.
 *
 * @param token Jeton d'authentification.
 * @param mediumId Identifiant du medium.
 */
export const deleteMediaFromDb = (token, body) => {
    const url = `/api-v1/tools/gallery/media/delete`
    return postRequest(url, body, token)
};